import React, { FC, useEffect, useState } from "react";
import { IonButton, IonInput, IonItem } from "@ionic/react";
import { API_URL } from "../../../actions/settings";
import NotificationPopUp from "../../extras/NotificationPopUp";
import AIModal from "../../elements/AIModal";

interface IProps {
    opened:boolean,
    setOpened:any,
    date:any,
    setData:any,
    id:string | null | undefined
};

async function updateDate(token: string,data:any,id:any) {
    return fetch(`${API_URL}/cost_avoidance/savings_date/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(data)
    }).then((res) => {
          if (res.ok) {
            return res.json();
          }
          else{
              console.log('error')
              res.json().then( err => {
                  NotificationPopUp("Error", err, "Error Saving Date")
                  // throw error here to use the catch
              })

          }
        }).catch(error => {
          NotificationPopUp("Error", error.message, "Error Saving Date")
        });
  }

const EditSavingsDateModal:FC<IProps> = (props) => {
    const [newDate, setNewDate] = useState('')
    // eslint-disable-next-line
    const [error, setError] = useState<any>(null)
    const [updating, setUpdating] = useState(false)

    useEffect(()=>{
        setNewDate(props.date)
    },[props.date])

    const handleSave = async () =>{
        setUpdating(true)
        const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
        const data = {
            'date':newDate
        }
        const res = await updateDate(token,data,props.id)
        setUpdating(false)
        if(res){
            props.setData((prevState: any) => {
                return {
                  ...prevState,
                  'savings_date': res.date,
                }})
            props.setOpened(false)
        }

    }

    return <div>
        <AIModal title="Edit Savings Start Date" opened={props.opened} setOpened={props.setOpened}>
            <div className="center-all text-dark-blue">
                <div style={{width:'100%'}}>
                <IonItem lines="none" style={{width:'100%'}}>
                    <IonInput
                    label='Savings Start Date' labelPlacement='start'
                      className={error === null ? "valid" : "ion-invalid ion-touched"}
                      type="date"
                      aria-labelledby="campus optimizer date"
                      value={newDate}
                      placeholder="Start Date"
                      onIonInput={(e: any) =>
                        setNewDate(e.detail.value!)
                      }
                      errorText={error}
                    />
                </IonItem>
                <IonButton disabled={updating} onClick={()=>handleSave()}>{updating ? 'Saving ...' : 'Save'}</IonButton>
                </div>
            </div>
        </AIModal>
    </div>
};

export default EditSavingsDateModal;